import { useParams } from '@tanstack/react-router';

import { CompanyOverviewPage } from '../../components/CompanyOverviewPage';
import { CustomersTable } from '../detail/components/CustomersTable';

export const CustomerCompaniesPage = () => {
    const { groupId } = useParams({ from: '/_app/customer-groups/$groupId/companies' });

    return (
        <CompanyOverviewPage>
            <CustomersTable groupId={groupId} />
        </CompanyOverviewPage>
    );
};
